module.exports = __webpack_public_path__ + "static/31-img-3-c61189c3ee77ef91c4656f1919680adc.png";